import generateTypes from '../utils/generateTypes';

export const GET_CUSTOM_QR_CODES = generateTypes('GET_CUSTOM_QR_CODES');
export const RESET_CUSTOM_QR_CODES = generateTypes('RESET_CUSTOM_QR_CODES');
